import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./IOSInputBar.css";

interface IOSInputBarProps {
  onAddItem: (itemName: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

/** Mirrors the floating quick-add control used by the current iOS theme. */
const IOSInputBar: React.FC<IOSInputBarProps> = ({
  onAddItem,
  disabled = false,
  placeholder,
}) => {
  const { t } = useTranslation();
  const [itemName, setItemName] = useState<string>("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!itemName.trim() || disabled) return;
    onAddItem(itemName);
    setItemName("");
  };

  // Use the correct translation key that matches the iOS app
  const defaultPlaceholder =
    placeholder ||
    t("sharedGroceryList.add_item_placeholder") ||
    "Artikel hinzufügen...";

  return (
    <div className="ios-input-bar-container">
      <form
        onSubmit={handleSubmit}
        className="ios-input-bar-form"
        autoComplete="off"
      >
        <div className="ios-input-bar">
          <input
            type="text"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
            placeholder={defaultPlaceholder}
            disabled={disabled}
            aria-label={defaultPlaceholder}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            inputMode="text"
            className="ios-input-bar-textfield"
          />

          <button
            type="submit"
            disabled={itemName.trim() === "" || disabled}
            aria-label={t("sharedGroceryList.add_item_button") || "Add item"}
            className="ios-input-bar-button"
          >
            <svg
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default IOSInputBar;
